import { Menu } from 'antd'
import { Typography } from 'components/Typography'
import { TMenuItems } from './types'
import useRouter from '../../../../../../../hooks/useRouter'
import { routes } from '../../../../../../../router'
import { userActions } from './constants'

export const UserMenuItems = ({
  user,
  setVisible,
  isArchived,
  onArchive
}: TMenuItems) => {
  const { navigate } = useRouter()

  const handleClick = (key: string) => {
    setVisible(false)
    switch (key) {
      case 'edit':
        return navigate(
          `${routes.createUserProfile}/${user.uuid}?fromCommunity=true`
        )
      case 'archive':
        return onArchive(user)
      default:
        return
    }
  }

  return (
    <Menu className="menu-items-wrapper">
      {userActions.map((i) =>
        isArchived && i.key === 'archive' ? null : (
          <Menu.Item key={i.key} onClick={() => handleClick(i.key)}>
            <Typography.Body1>{i.label}</Typography.Body1>
          </Menu.Item>
        )
      )}
    </Menu>
  )
}
